/**
 * Онбординг и профиль: хобби, тесты способностей и входной тест.
 * Проверка ответов входного теста — на сервере: клиенту он уходит без ключей.
 */

import {
  LEARNING_LANGUAGE_HEADER,
  type AptitudeResult,
  type CompleteOnboarding,
  type PlacementAnswer,
  type PlacementOutcome,
  type PlacementQuestionView,
  type ProfileView,
  type SubmitAptitude,
} from '@aptile/shared';

import { useLearningStore } from '../store/learningStore';
import { useLocaleStore } from '../store/localeStore';
import { apiRequest, jsonBody } from './client';

export function fetchProfile(userId: string): Promise<ProfileView> {
  const query = new URLSearchParams({ userId });
  return apiRequest<ProfileView>(`/api/profile?${query.toString()}`);
}

/** Вводный тур закрыт (пройден или пропущен) — больше не показывать. */
export function markTutorialSeen(): Promise<ProfileView> {
  return apiRequest<ProfileView>('/api/profile/tutorial-seen', { method: 'POST' });
}

/** Имя, которым ученик представился Тико. */
export function saveUserName(userName: string): Promise<ProfileView> {
  return apiRequest<ProfileView>('/api/profile/name', { method: 'PUT', body: jsonBody({ userName }) });
}

export function saveHobbies(userId: string, hobbies: readonly string[]): Promise<ProfileView> {
  return apiRequest<ProfileView>('/api/profile/hobbies', { method: 'PUT', body: jsonBody({ userId, hobbies }) });
}



/** Изучаемый язык гостя: токена нет, поэтому заголовок языка — вручную. */
const guestHeaders = (): Record<string, string> => ({ [LEARNING_LANGUAGE_HEADER]: useLearningStore.getState().activeLanguage });

/** Вопросы входного теста — и гостю (онбординг до входа), и ученику. */
export function fetchPlacementTest(): Promise<readonly PlacementQuestionView[]> {
  const query = new URLSearchParams({ ui: useLocaleStore.getState().uiLanguage });
  return apiRequest<readonly PlacementQuestionView[]>(`/api/guest/placement?${query.toString()}`, { headers: guestHeaders() });
}

/** Проверка теста гостя без записи: ступень видна сразу, сохранится после входа. */
export function scoreGuestPlacement(answers: readonly PlacementAnswer[]): Promise<PlacementOutcome> {
  return apiRequest<PlacementOutcome>('/api/guest/placement/score', { method: 'POST', body: jsonBody({ answers }), headers: guestHeaders() });
}

/** Онбординг, пройденный до входа, — в аккаунт (ответы теста сервер проверит сам). */
export function completeOnboarding(input: CompleteOnboarding): Promise<ProfileView> {
  return apiRequest<ProfileView>('/api/onboarding/complete', { method: 'POST', body: jsonBody(input) });
}

export function submitPlacement(userId: string, answers: readonly PlacementAnswer[]): Promise<PlacementOutcome> {
  return apiRequest<PlacementOutcome>('/api/placement', { method: 'POST', body: jsonBody({ userId, answers }) });
}

/** Итоги тестов способностей → профиль и стартовый план уроков. */
export function submitAptitude(input: SubmitAptitude): Promise<AptitudeResult> {
  return apiRequest<AptitudeResult>('/api/profile/aptitude', { method: 'POST', body: jsonBody(input) });
}
